import { IconButton, Tooltip } from "@mui/material";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import { useThemeMode } from "../theme/ThemeModeProvider";

export default function ThemeToggle({ size = "medium", sx }) {
    const { mode, toggleTheme } = useThemeMode();
    const isLight = mode === "light";

    return (
        <Tooltip title={isLight ? "Switch to dark mode" : "Switch to light mode"}>
            <IconButton
                onClick={toggleTheme}
                size={size}
                aria-label="Toggle light or dark theme"
                sx={{
                    color: "inherit",
                    border: (t) => `1px solid ${t.palette.divider}`,
                    ...sx,
                }}
            >
                {isLight ? <DarkModeOutlinedIcon fontSize={size} /> : <LightModeOutlinedIcon fontSize={size} />}
            </IconButton>
        </Tooltip>
    );
}
